import 'modules/intro-headline/intro-headline';
import OdoCarousels from 'modules/odo-carousel/odo-carousels';
import 'modules/about-teams/about-teams';
import 'modules/blockquote/blockquote';
import BirdTout from 'modules/bird-tout/bird-tout';
import 'modules/studio-life/studio-life';
import InstagramFeed from 'modules/instagram-feed/instagram-feed';
import 'modules/learning-together/learning-together';
import 'modules/article-tout/article-tout';
import 'modules/local-favorites/local-favorites';
import 'modules/mega-link/mega-link';
import './index.scss';

OdoCarousels.initializeAll();
BirdTout.initializeAll();
InstagramFeed.initializeAll();
